import { isValidPhoneNumber as isValidPhoneNumberLib, parsePhoneNumberWithError } from 'libphonenumber-js';

export const e164Format = (phone) => {
    try {
        const phoneInstance = parsePhoneNumberWithError(phone, 'US');
        return phoneInstance.format('E.164');
    } catch {
        return null;
    }
};

export const isValidPhoneNumber = (phone) => {
    if (phone === undefined || phone === null) {
        return false;
    }

    try {
        return isValidPhoneNumberLib(phone, 'US');
    } catch {
        return false;
    }
};
